module.exports = __webpack_public_path__ + "static/media/dots.bc50aefa.svg";